module.exports = __webpack_public_path__ + "img/2022_10_dandelion_castle_fin_web.c02f7224.png";